import React from "react"
import EditableTableHolder from "../components/EditableTableHolder"
import { connect } from "react-redux"
import { authorize } from "../decorators/authorize"
import requireStore from "../decorators/requireStore"
import { salesPage } from "../config/routesInfo"
import {
  clear,
  editSale,
  filter,
  openPage,
  search,
  sort,
  refresh,
  setDateRange,
} from "../ducks/tabularData/sales"
import { withTranslation } from "react-i18next"

const columns = [
  {
    title: "cashboxId",
    name: "cashboxId",
    dataType: "number",
    sortable: true,
  },
  {
    title: "checkNum", // Translate
    name: "saleId",
    dataType: "number",
    sortable: true,
  },
  {
    title: "dateSale",
    name: "at",
    dataType: "date",
    sortable: true,
  },
  {
    title: "employe",
    name: "login",
    dataType: "string",
    render: (item) =>
      item.login + " " + (item.firstName || "") + " " + (item.lastName || ""),
    sortable: true,
  },
  // {
  //   title: "Скидка",
  //   name: "discount",
  //   dataType: "number",
  //   render: (item) => parseInt(item.discount || 0) + "%",
  //   sortable: true,
  // },
  {
    title: "totalPrice",
    name: "total",
    dataType: "number",
    sortable: true,
    filters: ["range"],
  },
  {
    title: "note",
    name: "type",
    dataType: "string",
    sortable: true,
  },
]

const innerColumns = [
  {
    title: "Штрих-код",
    name: "barcode",
    dataType: "string",
  },
  {
    title: "title",
    name: "name",
    dataType: "string",
  },
  {
    title: "priceSale",
    name: "salePrice",
    dataType: "number",
    // editable: true,
  },
  {
    title: "quantity",
    name: "quantity",
    dataType: "number",
  },
  {
    title: "unitsMeasuring",
    name: "shortName",
    dataType: "string",
  },
  {
    title: "discount",
    name: "discountPercent",
    dataType: "number",
    render: (item) => parseInt(item.discount || 0) + "%",
  },
]

@authorize(...salesPage.permissions)
@requireStore()
@withTranslation()
@connect(
  (state) => ({
    activeFilters: state.sales.filters,
    sortedBy: state.sales.sortedBy,
    sortedAsc: state.sales.sortedAsc,
    data: state.sales.data,
    isLoading: state.sales.pendingRequests > 0,
    pagesCount: state.sales.totalPages,
    currentPage: state.sales.currentPage,
    currentStoreId: state.profile.currentStore.id,
    totalCount: state.sales.totalCount,
    startDate: state.sales.startDate,
    endDate: state.sales.endDate,
  }),
  (dispatch) => ({
    onSearch: (...data) => dispatch(search(...data)),
    refresh: () => dispatch(refresh()),
    clear: () => dispatch(clear()),
    onPageSelect: (...data) => dispatch(openPage(...data)),
    onEdit: (...data) => dispatch(editSale(...data)),
    onSort: (...data) => dispatch(sort(...data)),
    changeFilters: (...data) => dispatch(filter(...data)),
    setDateRange: (startDate, endDate) =>
      dispatch(setDateRange(startDate, endDate)),
  }),
)
export default class SalesPage extends React.Component {
  state = {
    checkNum: -1,
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    const { currentStoreId, refresh } = this.props
    if (newProps.currentStoreId !== currentStoreId) {
      refresh()
    }
  }

  componentWillUnmount() {
    this.props.clear()
  }

  componentDidMount() {
    this.props.refresh()
    const { onSort } = this.props
    onSort("at")
  }

  setCheckNum = (num) => {
    this.setState({ checkNum: num })
  }

  getCheckNum = () => this.state.checkNum

  render() {
    const {
      activeFilters,
      sortedBy,
      sortedAsc,
      data,
      isLoading,
      currentPage,
      pagesCount,
      onSearch,
      onPageSelect,
      onSort,
      changeFilters,
      onEdit,
      totalCount,
      setDateRange,
      startDate,
      endDate,
      t,
    } = this.props
    const tableData = {
      columns,
      data,
      activeFilters,
      sortedBy,
      sortedAsc,
      isLoading,
      onSort,
      changeFilters,
    }
    const innerTable = {
      propName: "items",
      title: "salesReportPage",
      tableData: { columns: innerColumns, data: [], onEdit: onEdit },
    }
    return (
      <EditableTableHolder
        title={t("salesPage")}
        info={
          <div>
            <p>
              {t(
                "In this section you can observe information on sales, namely",
              )}
            </p>
            <ul>
              <li>{t("Date of sale")}</li>
              <li>{t("The cashier who conducted the sale")}</li>
              <li>{t("Total cost")}</li>
              <li>{t("Various sales notes")}</li>
            </ul>
            <p>
              {t(
                "Click on the sale you are interested in for more information",
              )}
            </p>
          </div>
        }
        currentPage={currentPage}
        pagesCount={pagesCount}
        searchInfo="Поиск по наименованию товара"
        onPageSelect={onPageSelect}
        onSearch={onSearch}
        tableData={tableData}
        isLoading={isLoading}
        innerTable={innerTable}
        startDate={startDate}
        endDate={endDate}
        onSetDateRange={setDateRange}
        // noOptions
        noOptionsNested
        totalCount={totalCount || 0}
        salesPage={true}
        checkNum={this.getCheckNum}
        setCheckNum={this.setCheckNum}
      />
    )
  }
}
